import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MenuStateService {

  mobileUserMenuOpen = signal(false);
  mobileTabNaviOpen = signal(false);
  releaseNotesOpen = signal(false);

  toggleMobileUserMenu(isOpen?: boolean): void {
    this.mobileUserMenuOpen.update((state) => (typeof isOpen === 'boolean' ? isOpen : !state));
  }

  toggleMobileTabNavi(isOpen?: boolean): void {
    this.mobileTabNaviOpen.update((state) => (typeof isOpen === 'boolean' ? isOpen : !state));
  }

  toggleReleaseNotes(isOpen?: boolean): void {
    this.releaseNotesOpen.update((state) => (typeof isOpen === 'boolean' ? isOpen : !state));
  }

  closeAll() {
    this.toggleMobileUserMenu(false);
    this.toggleMobileTabNavi(false);
    this.toggleReleaseNotes(false);
  }
}
